import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import { Values } from "@src/Tools/Values";
import AuthApiTokensContent from "./AuthApiTokensContent/AuthApiTokensContent";

interface IProps {
  management?: IManagementStore;
}

@inject("management", "values")
@observer
export default class AuthApiTokens extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([this.props.management.getOAuthApiTokens(), this.props.management.getLocations()]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("oAuthApiTokens");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <AuthApiTokensContent />}</div>;
  }
}
